import Lightning from "@fuse/assets/images/legacy/img-lightning.svg"
import People from "@fuse/assets/images/legacy/img-people.svg"
import Sunglasses from "@fuse/assets/images/legacy/img-sunglasses.svg"
import TextBubble from "@fuse/assets/images/legacy/img-text-bubble.svg"

import ContainerElements from "./Containerelements"

const Content = [
  {
    img: People,
    heading: "Authentic circles",
    content: "Deepen bonds with friends and expand your social circle.",
  },
  {
    img: TextBubble,
    heading: "No more group chat chaos",
    content:
      "We will streamline the who, what, and when - tailored to your settings.",
  },
  {
    img: Sunglasses,
    heading: "Stay under the radar",
    content: "Be active, without the whole world watching.",
  },
  {
    img: Lightning,
    heading: "A Freemium promise",
    content:
      "Experience the best for free, everyone deserves to feel connected.",
  },
]

const FeatureContainer = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
      {Content.map((content, index) => (
        <ContainerElements
          key={index.toString()}
          img={content.img}
          heading={content.heading}
          content={content.content}
        />
      ))}
    </div>
  )
}

export default FeatureContainer
